export default "__VITE_ASSET__rO7rL5Mw__"